import { ReactNode } from "react";
import { BranchCode } from "api/risk";
import { useSubscriptionProcessState } from "features/subscription-process/contexts/selectors/selectors";
import { GuaranteesCard } from "./guarantees-card/GuaranteesCard";
import { resolvePricingEntityCard } from "./pricingEntityStrategy";
import { usePricingParcContext } from "../contexts/PricingParcContext";

interface PricingHeaderProps {
  /** What stands to the right of the person; the guarantees block by default. */
  rightBlock?: ReactNode;
}

export const PricingHeader: React.FC<PricingHeaderProps> = ({ rightBlock }) => {
  const { branchCode } = useSubscriptionProcessState();
  const { isParc } = usePricingParcContext();

  const EntityCard = resolvePricingEntityCard(isParc, branchCode as BranchCode);

  return (
    <div className="relative flex flex-col xl:flex-row gap-4 p-4 border bg-white rounded-xl shadow">
      <div className="flex-none w-full xl:w-[250px] 2xl:w-[320px]">
        {EntityCard && <EntityCard />}
      </div>
      {rightBlock ?? <GuaranteesCard />}
    </div>
  );
};
